(function() {
	'use strict';
	angular.module('app.leanProjects')
		.controller('taskGantt', taskGantt);
	
	taskGantt.$inject = ['$scope', '$translate', '$locale', 'GanttObjectModel', 'moment'];
	
	function taskGantt($scope, $translate, $locale, ObjectModel, moment) {
		var vm = this;
		vm.close = close;

		var colorMap = {
			'30-bad': '#F7B6C4', // radar light
			'20-warn': '#FFE349', // yellow500 (old palette)
			'10-good': '#C1DAB4', // earth light
			'complete': '#96D0FB' // booster tint
		};

		var colorClassMap = {
			'30-bad': 'bad',
			'20-warn': 'warn',
			'10-good': 'good',
			'complete': 'complete'
		};

		function init() {
			organizeTasks($scope.tasks);
		}
		
		init();
		var objectModel;

		vm.options = {
			headersFormats: {
				month: function(column) {;
					return column.date.locale($locale.id).format('MMM');
				}
			},
			dateFormat: 'MMM D, YYYY',
			mode: 'custom',
			scale: 'month',
			sortMode: undefined,
			sideMode: 'Table',
			daily: false,
			height: window.innerHeight - 150,
			width: true,
			zoom: 1,
			columns: ['model.name', 'model.responsible', 'model.percentComplete'],
			treeTableColumns: ['from', 'to'],
			columnsHeaders: {'model.name' : $translate.instant('Task Name'), 'model.responsible': $translate.instant('Responsible'), 'model.percentComplete': '%'},
			columnsClasses: {'model.name' : 'gantt-column-task-name', 'model.responsible' : 'gantt-column-responsible', 'model.percentComplete' : 'gantt-column-percent-complete'},
			columnsFormatters: {
				'model.percentComplete': function(from) {
					return from !== undefined && from != 0? from + '%' : undefined;
				}
			},
			treeHeaderContent: '{{getHeader()}}',
			columnsHeaderContents: {'model.name': '{{getHeader()}}', 'model.responsible': '{{getHeader()}}', 'model.percentComplete': '<span tooltip-placement="bottom" tooltip-append-to-body="true" uib-tooltip="% Complete">{{getHeader()}}</span>'},
			rowContentEnabled: true,
			autoExpand: 'true',
			taskOutOfRange: 'truncate',
			fromDate: moment(null),
			toDate: undefined,
			rowContent: '<span title="{{row.model.name}}">{{row.model.name}}</span>',
			taskContent : '{{task.model.name}}',
			tootltipContnt : '{{task.model.name}}</br>' +
			'<small>' +
			'{{task.model.responsible}}' +
			'</small></br>' +
			'<small>' +
			'{{getFromLabel() + \' - \' + getToLabel()}}' +
			'</small></br>' + 
			'<small>Progress : {{task.model.progress.percent}}%</small>',
			allowSideResizing: true,
			labelsEnabled: true,
			draw: false,
			readOnly: false,
			api: function(api) {
				// API Object is used to control methods and events from angular-gantt.
				vm.api = api;
			
				api.core.on.ready($scope, function() {
					api.side.setWidth(350);
					objectModel = new ObjectModel(api);

					api.side.on.resizeEnd($scope, function(width){
						if (width > 340) {
							var newWidth = width - 340;
							newWidth = newWidth / 3;
							jQuery('.gantt-column-task-name').css('width', 170 + (newWidth * 2));
							jQuery('.gantt-column-responsible').css('width', 120 + newWidth);
							jQuery('.gantt-column-percent-complete').css('width', 50);
						}
					});
				});
			}
		};
		// Visual two way binding.
		vm.live = {};
		
		vm.canAutoWidth = function(scale) {
			if (scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/)) {
				return false;
			}
			return true;
		};
		vm.getColumnWidth = function(widthEnabled, scale, zoom) {
			if (!widthEnabled && $scope.canAutoWidth(scale)) {
				return undefined;
			}
			
			if (scale.match(/.*?week.*?/)) {
				return 150 * zoom;
			}
			
			if (scale.match(/.*?month.*?/)) {
				return 80 * zoom;
			}
			
			if (scale.match(/.*?quarter.*?/)) {
				return 500 * zoom;
			}
			
			if (scale.match(/.*?year.*?/)) {
				return 800 * zoom;
			}
			
			return 40 * zoom;
		};

		function lateTask(taskCompletionDate, taskState) {
			var today = new Date().setHours(0,0,0,0);
			taskCompletionDate = new Date(taskCompletionDate);
			if( taskState === 'Pending' || taskState === 'Started'){
				if( taskCompletionDate < today) {
					return true;
				}
			}
			return false;
		}

		function organizeTasks(taskList) {
			var tasks = [];
			var taskState = '';
			angular.forEach(taskList, function(task, index) {
				taskState = task.stateType === 'Completed' ? 'complete' : task.taskState;
				tasks.push({
					name: task.name, 
					taskNdx: task.ndx,
					responsible: task.firstName + ' ' + task.lastName,
					percentComplete: task.percentComplete,
					tasks: [
						{
							dataNdx: index,
							name: task.name,
							responsible: task.firstName + ' ' + task.lastName,
							taskNdx: task.ndx,
							from: new Date(task.projectedStartDate), 
							to: new Date(task.projectedCompleteDate),
							progress: {
								'percent': task.percentComplete,
								'color': '#F4CE00'
							},
							color: colorMap[taskState],
							classes: colorClassMap[taskState],
							'movable': {
								'enabled': false,
								'allowMoving': false,
								'allowResizing': false,
								'allowRowSwitching': false
							}
						}
					]
				});
			});
			vm.data = tasks;
		}
		function close() {
			$scope.result();
		}
	}
})();